import { render, staticRenderFns } from "./LiveClassScheduleInfo.vue?vue&type=template&id=47fe1b54&scoped=true&"
import script from "./LiveClassScheduleInfo.vue?vue&type=script&lang=js&"
export * from "./LiveClassScheduleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fe1b54",
  null
  
)

export default component.exports